module.exports = __webpack_public_path__ + "img/02.87fa92d4.png";